import React from 'react';
import {
  WhiteLabelContentContainer
} from '../WLContentContainer/WhiteLabelContentContainer';
import { Field } from 'redux-form';
import { Col, Row } from 'react-bootstrap';
import { HorizontalFormControl, PublicCheckbox } from '../../../../common/components';
import { Divider } from '../../../brochure/components/StyledComponents/StyledComponents';


const ThirdPartyScripts = () => {
  return (
    <WhiteLabelContentContainer title={'Third Party Scripts'}>

      <>
        <Field
          name="meta.whitelabel.cloudfront_enabled"
          label={'Cloud Front Script Enabled'}
          component={PublicCheckbox}
        />
        <Divider my={2} />
        <Row>
          <Col sm={12}>
            <Field
              name="meta.whitelabel.gtm_id"
              label={'GTM Id'}
              // fieldSize={10}
              component={HorizontalFormControl}/>
          </Col>
        </Row>
      </>

    </WhiteLabelContentContainer>
  );

};
export default ThirdPartyScripts;
